module.exports = require('stream-to').buffer


//////////////////
// WEBPACK FOOTER
// ./~/stream-to-buffer/index.js
// module id = 851
// module chunks = 0